import { blocks } from '@yola/ws-sdk';
import analytics from 'src/js/modules/analytics';
import getParentBlockByElement from '../../../../blocks/helpers/get-parent-block-by-element';

const {
  segment: {
    constants: { events },
    trackers: { trackEvent },
  },
} = analytics;

const trackTextDecorationSettingsDialogCanceled = ({ targetElement }) => {
  const blockElement = getParentBlockByElement(targetElement);
  const blockId = blocks.accessors.getBlockIdByElement(blockElement);

  trackEvent(events.TEXT_DECORATION_SETTINGS_DIALOG_CANCELED, { blockId });
};

export default trackTextDecorationSettingsDialogCanceled;
